import { PERMISSIONS, ROLE_CONFIG_KEYS } from "common/constants";
import APIConstants from "common/constants/APIConstants";
import { useAuthContext } from "common/contexts/AuthContext";
import activeImage from "common/icons/activeNotificationGreen.svg";
import ESLogo from "common/icons/es_logo.png";
import image from "common/icons/notificationGreen.svg";
import { checkPermission } from "common/utils";
import { api } from "common/utils/APIMethods";
import i18next from "i18next";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { Link, useMatch, useNavigate } from "react-router-dom";
import HeaderLink from "./HeaderLink";

function showNotification(data, navigate) {
  if (!("Notification" in window)) {
    // Dont do anything if notifications are not supported by the browser
  } else if (Notification.permission === "granted") {
    const notification = new Notification(i18next.t("valuemedi_notification"), {
      body: i18next.t("new_notification", { length: data.length }),
      icon: ESLogo
    });
    notification.onclick = () => {
      window.focus();
      navigate("/notifications");
    };
  } else if (Notification.permission !== "denied") {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        const notification = new Notification(
          i18next.t("valuemedi_notification"),
          {
            body: i18next.t("new_notification", { total: data.length }),
            icon: ESLogo
          }
        );
        notification.onclick = () => {
          window.focus();
          navigate("/notifications");
        };
      }
    });
  }
}

const NotificationHeader = () => {
  const isNotificationsPage = useMatch("/Notifications");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { newNotifications } = APIConstants;
  const { authConfig, parsedRoleConfig } = useAuthContext();

  const notificationsQueryEnabled = checkPermission(parsedRoleConfig, {
    config: ROLE_CONFIG_KEYS.notifications,
    permission: PERMISSIONS.read
  });

  const fetchNewNotifications = () =>
    api(
      {
        url: newNotifications
      },
      authConfig
    );

  const { data: newNotificationsData = [] } = useQuery(
    "newNotifications",
    fetchNewNotifications,
    {
      enabled: notificationsQueryEnabled,
      refetchInterval: 300000,
      refetchIntervalInBackground: true
    }
  );

  useEffect(() => {
    if (newNotificationsData.length > 0) {
      showNotification(newNotificationsData, navigate);
    }
  }, [newNotificationsData]);

  return (
    <Link to="/notifications">
      <HeaderLink
        image={image}
        activeImage={activeImage}
        match={isNotificationsPage}
        active={newNotificationsData.length > 0}
        text={t("notifications")}
        showText={false}
      />
    </Link>
  );
};

export default NotificationHeader;
